import styled from 'styled-components'
import { font, bp } from 'lib/core/resources/helpers/styled'
import { BREAKPOINT } from 'app/sofia/resources/constants'

export const Container = styled.div`
  background: linear-gradient(180deg, ${props => props.theme.palette.general.soft} 0%, ${props => props.theme.palette.general.alphaMutted} 100%);
  padding: 32px 0;
  font: ${font('default', 'normal', '16px/1.5')};
  color: ${props => props.theme.palette.primary.alphaDark};

  > div {
    width: 90%;
    max-width: ${props => props.theme.maxWidth};
    margin: auto;
    padding: 0 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  ul {
    list-style: none;
    padding: 0;
  }

  a,
  .contact_trigger {
    cursor: pointer;
    color: ${props => props.theme.palette.primary.alphaDark};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
      color: ${props => props.theme.palette.general.strong};
    }
  }

  h2 {
    font: ${font('default', 'bold', '18px/1.5')};
    text-transform: uppercase;

    @media (max-width: ${BREAKPOINT.MD}) {
      font: ${font('default', 'bold', '16px/1.5')};
    }
  }

  .footer__main-column {
    width: 55%;
    display: flex;
    justify-content: space-between;

    > div {
      margin: 0 15px;
    }

    @media (max-width: ${BREAKPOINT.LG}) {
      width: 75%;
    }

    @media (max-width: ${BREAKPOINT.MD}) {
      order: -1;
      flex-grow: 1;

      > div {
        width: 33.33%;
        margin: 0 10px;
      }
    }

    ${bp('sm')`
      width: 100%;
      flex-direction: column;
      order: unset;

      > div {
        width: 100%;
      }
    `}
  }
`

export const FooterLogo = styled.div`
  display: flex;

  @media (max-width: ${BREAKPOINT.MD}) {
    order: 4;
    width: 35%;
    max-width: 180px;
    text-align: right;
  }

  ${bp('sm')`
    order: 0;
    width: 100%;
    text-align: left;
    margin: 30px 0;
    max-width: unset;
  `}

  > a {
    margin-top: auto;
  }

  img {
    max-width: 180px;
    ${bp('sm')`
      max-width: 280px;
    `}
  }
`
